import React from 'react';
import { useTranslation } from 'react-i18next';
import { JournalMobileCard } from '@/pages/Overview/JournalMobileCard';
import type { Journal } from '@/types/journal';
import { getJournalKey, getTeacherNames } from '@/utils/journal';

interface Props {
  journals: Journal[];
  onSelect: (journal: Journal) => void;
}

export const JournalMobileList: React.FC<Props> = ({ journals, onSelect }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-1 flex-col gap-3 rounded-t-2xl bg-card px-4 pt-4 pb-6 shadow-card">
      <h1 className="text-headline-20 text-foreground">
        {t('overview.tabs.journals')}
      </h1>

      {journals.map((journal) => (
        <JournalMobileCard
          key={getJournalKey(journal.journalId)}
          name={journal.name}
          teachers={getTeacherNames(journal)}
          onSelect={() => onSelect(journal)}
        />
      ))}
    </div>
  );
};
